export enum EVisitType {
  URGENT_CARE = 'URGENT_CARE',
  URGENT_CARE_FOLLOWUP = 'URGENT_CARE_FOLLOWUP',
  PSYCHOLOGY = 'PSYCHOLOGY',
  WELLNESS = 'WELLNESS',
  CARE_MANAGEMENT = 'CARE_MANAGEMENT',
  PSYCHIATRY = 'PSYCHIATRY',
  MOVEIN = 'MOVEIN',
}
